// extracted by mini-css-extract-plugin
module.exports = {"dashboards":"Presentation_dashboards__2FSAX"};